import { Component, Inject, OnInit } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
} from '@angular/material/dialog';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatInput, MatLabel } from '@angular/material/input';

interface QuoteEditForm {
    customerPurchaseNumber: FormControl<string>;
    templateDescription: FormControl<string>;
    primarySchemes: FormControl<string>;
}

interface QuoteEditData {
    customerPurchaseNumber: string;
    templateDescription: string;
    primarySchemes: string;
}

export function openQuoteEditDialog(dialog: MatDialog, data: QuoteEditData) {
    const dialogRef = dialog.open<QuoteEditDialogComponent, QuoteEditData, QuoteEditData>(QuoteEditDialogComponent, {
        autoFocus: false,
        width: '500px',
        data,
    });
    return dialogRef.afterClosed();
}

@Component({
    selector: 'app-quote-edit-dialog',
    standalone: true,
    imports: [
        TranslateModule,
        MatDialogActions,
        MatButton,
        MatDialogClose,
        MatDialogContent,
        MatFormField,
        MatInput,
        MatLabel,
        ReactiveFormsModule,
    ],
    templateUrl: './quote-edit-dialog.component.html',
    styleUrl: './quote-edit-dialog.component.scss',
})
export class QuoteEditDialogComponent implements OnInit {
    public editForm: FormGroup<QuoteEditForm>;

    constructor(@Inject(MAT_DIALOG_DATA) public data: QuoteEditData) {}

    ngOnInit() {
        this.editForm = new FormGroup({
            customerPurchaseNumber: new FormControl(this.data.customerPurchaseNumber, Validators.required),
            templateDescription: new FormControl(this.data.templateDescription, Validators.required),
            primarySchemes: new FormControl(this.data.primarySchemes, Validators.required),
        });
        this.editForm.get('templateDescription').updateValueAndValidity();
    }

    get dialogResult(): QuoteEditData {
        const { templateDescription, customerPurchaseNumber, primarySchemes } = this.editForm.getRawValue();
        return { templateDescription, customerPurchaseNumber, primarySchemes };
    }
}
